// OneTrust global variable declaration
declare global {
    interface Window {
        OnetrustActiveGroups?: string;
    }
}

export function getDeviceType(): "Desktop" | "Tablet" | "Mobile" {
    // Use matchMedia instead of innerWidth to avoid forced reflow
    if (window.matchMedia("(min-width: 1024px)").matches) {
        return "Desktop";
    } else if (window.matchMedia("(min-width: 768px)").matches) {
        return "Tablet";
    } else {
        return "Mobile";
    }
}

// Set cookie for backward compatibility with QbankImageService
// TODO: Remove when migrating to picture elements everywhere
const deviceType = getDeviceType();
document.cookie = `deviceType=${deviceType}; path=/;`;

